import {
    createElementVNode as _$ce,
    createTextVNode as _$ct,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {XMarkdown, Switch} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'span', [
                _$ct('enableFormula: '),
                _$cc(Switch, {
                    'value': this.get('enableFormula'),
                    'ev-$change:value': this.setEnableFormula
                })
            ], 4),
            _$ce(2, 'span', [
                _$ct('useBrackets: '),
                _$cc(Switch, {
                    'value': this.get('useBrackets'),
                    'ev-$change:value': this.setUseBrackets
                })
            ], 4)
        ], 4, 'xmarkdown-demo-formula-actions'),
        _$cc(XMarkdown, {
            'content': this.getContent(),
            'enableFormula': this.get('enableFormula'),
            'formulaDelimiters': this.getFormulaDelimiters(),
            'formulaMacros': this.getFormulaMacros()
        })
    ], 4, 'xmarkdown-demo-formula');
};